// extracted by mini-css-extract-plugin
module.exports = {"variant-table-wrapper":"VariantTable_variant-table-wrapper__3nB8c"};